<template>
  <div>
    <NewListItem
      @click="$emit('click')"
      :expanded="expanded"
      :highlight="expanded"
      :clickToOpen="false"
    >
      <template v-slot:image>
        <v-icon size="32px">{{ mdiCalendar }}</v-icon>
      </template>

      <template v-slot:title="{ expanded }">
        <a
          class="event-title"
          :class="{ expanded: expanded }"
          :href="getUrl(event)"
        >
          {{ event.title }}
          <strong>
            {{ formatToDateSpanShort(event.start_at, event.end_at) }}
          </strong>
        </a>
      </template>

      <template v-slot:meta-columns="{ expanded }">
        <div>
          <v-chip
            :color="expanded ? '#ffffff' : '#3283f7'"
            label
            small
            :style="{
              color: expanded ? '#3283f7' : 'white',
              textTransform: 'uppercase',
              fontWeight: 'bold!important',
              padding: '2.83px 5.33px !important',
              paddingLeft: '10px !important',
            }"
          >
            <span style="padding-right: 4px !important">{{
              event.group.name
            }}</span>
          </v-chip>
        </div>
        <div style="display: flex; align-items: center">
          <v-icon size="18" style="padding-right: 4px">{{
            mdiCalendarCheck
          }}</v-icon>
          <span class="text ellipsis">
            <strong>
              {{ event.attends_count + event.guests_count }}
            </strong>
            <span>Anmeldungen</span>
          </span>
        </div>
      </template>
      <template v-slot:expanded-content>
        <div style="display: flex; justify-content: end">
          <Button
            @click="attend"
            color="white"
            class="action-button"
            :loading="loading"
            >Teilnehmen</Button
          >
          <Button
            @click="decline"
            color="white"
            class="action-button"
            style="margin-left: 8px"
            :loading="loading"
            >Absagen</Button
          >
        </div>
      </template>
    </NewListItem>
    <AttendWithGuestsDialog
      @guestsSelected="handleAttendCreation"
      v-model="dialog"
      :event="event"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from "vue"
import NewListItem from "components/NewListItem.vue"
import AttendWithGuestsDialog from "app/modules/events/rsvp-dashboard/AttendWithGuestsDialog.vue"
import Button from "components/UI/Button.vue"
import { Event, RsvpReply, RsvpRequest } from "suus-api"
import { mdiCalendar, mdiCalendarCheck, mdiClockTimeFourOutline } from "@mdi/js"
import { EventFunctions } from "app/modules/events/event.functions"
import { formatToDateSpanShort } from "app/util/date.helper"

export default defineComponent({
  name: "RSVPDashboardListItem",
  components: { Button, AttendWithGuestsDialog, NewListItem },
  props: {
    event: {
      type: Object as PropType<Event>,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const loading = ref(false)
    const dialog = ref(false)

    const attend = async () => {
      if (props.event.allow_guests) {
        dialog.value = true
      } else {
        const payload: RsvpRequest = {
          reply: RsvpReply.Attend,
          guests_count: 0,
        }
        emit("rsvpExpired", payload)
      }
    }

    const decline = async () => {
      const payload: RsvpRequest = {
        reply: RsvpReply.Decline,
      }
      emit("rsvpExpired", payload)
    }

    const handleAttendCreation = (guests_count) => {
      dialog.value = false
      const payload: RsvpRequest = {
        reply: RsvpReply.Attend,
        guests_count,
      }
      emit("rsvpExpired", payload)
    }

    return {
      mdiCalendar,
      mdiCalendarCheck,
      mdiClockTimeFourOutline,
      getUrl: EventFunctions.getUrl,
      formatToDateSpanShort,
      attend,
      decline,
      dialog,
      handleAttendCreation,
      loading,
    }
  },
})
</script>

<style scoped>
.event-title:hover {
  color: #3283f7;
}

.event-title.expanded:hover {
  color: #b9d0ff;
}

.action-button {
  flex: 1 1 auto;
}
</style>
